<template>
  <div>
    <Breadcrumbs main="" title="firebase notice"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">

        <div class="col-xl-12">
          <div class="card">
            <div class="card-header firebase-header">
              <h5>Notice List (Firebase)</h5>
            </div>

            <div class="card-body custom-scrollbar">
              <div class="todo">
                <div class="todo-list-wrapper">
                  <div class="todo-list-container">
                    <div class="table-responsive datatable-vue m-0 vue-smart">                                      
                      <v-table
                          :data="noticeList" class="table"
                          :currentPage.sync="basic.currentPage"
                          :pageSize="10"
                          @totalPagesChanged="basic.totalPages = $event"
                      >
                        <thead slot="head">
                          <th class="text-center">Market</th>
                          <th class="text-center">VCode</th>
                          <th class="text-center">Link</th>
                          <th class="text-center">Image</th>
                          <th>Contents</th>
                          <th class="text-center">Created</th>
                          <th class="text-center">Deadline</th>
                          <th class="text-center">Status</th>
                          <th class="text-center">Del</th>
                        </thead>
                        <tbody slot="body" slot-scope="{displayData}">
                          <tr v-for="(todo, index) in displayData" :key="index" class="task" :class="{'completed':todo.status == 'ACTIVE'}">
                            <td class="text-center">
                              <img class="img-20 img-fluid m-r-5" :src="require(`../../assets/images/market/${todo.market}.png`)" :alt="todo.market">
                              
                            </td>
                            <td class="text-center">{{ todo.versionCode }}</td>  
                            <td class="text-center">                                
                              <a v-bind:href="''+todo.link+''" target="_blank">
                                <i class="fa fa-external-link-square" :title="todo.link"></i>
                              </a>
                            </td>  
                            <td class="text-center"><img :src="`${todo.image}`" :title="todo.image" :width="50"></td> 
                            <td>
                              <p>
                                <b-div v-if="todo.message.english!=''"><b-badge pill variant="success">English : {{ todo.message.english }}</b-badge><br></b-div>
                                <b-div v-if="todo.message.korean!=''"><b-badge pill variant="info">Korean : {{ todo.message.korean }}</b-badge><br></b-div>
                                <b-div v-if="todo.message.spanish!=''"><b-badge pill variant="info">Spanish : {{ todo.message.spanish }}</b-badge><br></b-div>
                                <b-div v-if="todo.message.portuguese!=''"><b-badge pill variant="info">Portuguese : {{ todo.message.portuguese }}</b-badge><br></b-div>
                                <b-div v-if="todo.message.french!=''"><b-badge pill variant="info">French : {{ todo.message.french }}</b-badge><br></b-div>
                                <b-div v-if="todo.message.german!=''"><b-badge pill variant="info">German : {{ todo.message.german }}</b-badge><br></b-div>
                                <b-div v-if="todo.message.russian!=''"><b-badge pill variant="info">Russian : {{ todo.message.russian }}</b-badge></b-div>
                              </p>
                            </td>                              
                            <td class="text-center"><b-badge pill variant="success">{{ formatDate(todo.created) }}</b-badge></td>
                            <td class="text-center"><b-badge pill variant="success">{{ todo.deadline }}</b-badge></td>
                            <td class="text-center">
                              <span @click="taskActive(todo.id, todo.status)" class="action-box large complete-btn" title="Change status">
                                <b-badge v-if="todo.status=='INACTIVE'" pill variant="secondary"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                                <b-badge v-else pill variant="success"><i class="icon-check"></i>{{ todo.status }}</b-badge>
                              </span>  
                            </td>
                            <td class="text-center">
                              <span class="task-action-btn">
                                <span @click="tododelete(todo.id, todo.status)" class="action-box large delete-btn" title="Delete Task"><i class="icon"><i class="icon-trash"></i></i></span>
                              </span>                            
                            </td>
                          </tr>
                        </tbody>
                      </v-table>
                      <smart-pagination
                          :currentPage.sync="basic.currentPage"
                          :totalPages="basic.totalPages"
                      />
                    </div>
                  </div>
                </div>
                <div><notifications classes="task" group="noticeList" /></div>
              </div>
            </div>
          </div>                
        </div>

        <div class="col-xl-12"> 
          <div class="default-according">
            <b-card no-body class="mb-1">
              <b-card-header header-tag="div" role="tab" class="bg-primary">
                <h5 class="mb-0">
                  <b-button v-b-toggle.sectionWriteNotice><i class="fa fa-pencil-square"></i> Add new notice <span class="digits"></span></b-button>
                </h5>
              </b-card-header>
              <b-collapse id="sectionWriteNotice" accordion="my-accordion" role="tabpanel">
                <b-card-body>
                  <div class="row">
                    <div class="col-sm-12">

                      <div class="form-row">
                        <div class="col-md-4 mb-3">
                          <b-input-group prepend="Market">
                            <b-form-select v-model="notice_market" :options="MarketOptions" id="notice_market" name="notice_market"></b-form-select>
                          </b-input-group>
                        </div>
                        <div class="col-md-4 mb-3">  
                          <b-input-group prepend="Version Code">
                            <b-form-input v-model="notice_versionCode" type="number" placeholder="0" id="notice_versionCode" name="notice_versionCode"></b-form-input>
                          </b-input-group>                        
                        </div>
                        <div class="col-md-4 mb-3">
                          <b-input-group prepend="Deadline">
                            <datepicker v-model="notice_deadline" input-class="datepicker-here form-control digits" :format="format" id="notice_deadline" name="notice_deadline"></datepicker>                              
                          </b-input-group>                          
                        </div>
                      </div>

                      <div class="form-row">  
                        <div class="col-md-12 mb-3">
                          <b-input-group prepend="Link Url">
                            <b-form-input v-model="notice_link" type="text" placeholder="이동할 외부 링크 주소를 입력해주세요." id="notice_link" name="notice_link"></b-form-input>
                          </b-input-group>
                        </div>
                      </div>

                      <div class="form-row">  
                        <div class="col-md-12 mb-3">
                          <b-input-group prepend="Image Url">
                            <b-form-input v-model="notice_image" type="text" placeholder="공지사항의 대표 이미지 URL을 입력헤주세요." id="notice_image" name="notice_image"></b-form-input>
                          </b-input-group>
                        </div>
                      </div>
                    </div>  

                    <div class="col-sm-12 col-xl-12 xl-100">
                      <b-card header-tag="div" no-body>
                        <h5 slot="header">Message</h5>
                          <b-card-body>
                            <b-tabs pills slot="header" class="tabbed-card">
                              <b-tab title="English" active>
                                <template slot="title"><i class="fa fa-home"></i>English</template>
                                <b-form-textarea v-model="message_english" id="message_english" name="message_english" placeholder="Enter message here(Englis is default)..." rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-us" title="USA"></i>|<i class="flag-icon flag-icon-gb" title="United Kingdom"></i>|<i class="flag-icon flag-icon-au" title="Australia"></i>
                              </b-tab>
                              <b-tab title="Korean">
                                <template slot="title"><i class="fa fa-user"></i>Korean</template>
                                <b-form-textarea v-model="message_korean" id="message_korean" name="message_korean" placeholder="" rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-kr" title="Korea"></i>
                              </b-tab>
                              <b-tab title="Spanish">
                                <template slot="title"><i class="fa fa-address-book"></i>Spanish</template>
                                <b-form-textarea v-model="message_spanish" id="message_spanish" name="message_spanish" placeholder="" rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-es" title="Spain"></i>|<i class="flag-icon flag-icon-mx" title="Mexico"></i>
                              </b-tab>
                              <b-tab title="Portuguese">
                                <template slot="title"><i class="fa fa-address-book"></i>Portuguese</template>
                                <b-form-textarea v-model="message_portuguese" id="message_portuguese" name="message_portuguese" placeholder="" rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-pt" title="Portugal"></i>|<i class="flag-icon flag-icon-br" title="Brazil"></i>
                              </b-tab>  
                              <b-tab title="French">
                                <template slot="title"><i class="fa fa-address-book"></i>French</template>
                                <b-form-textarea v-model="message_french" id="message_french" name="message_french" placeholder="" rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-fr" title="France"></i>|<i class="flag-icon flag-icon-ca" title="Canada"></i>
                              </b-tab> 
                              <b-tab title="German">
                                <template slot="title"><i class="fa fa-address-book"></i>German</template>                                  
                                <b-form-textarea v-model="message_german" id="message_german" name="message_german" placeholder="" rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-de" title="German"></i>
                              </b-tab>
                              <b-tab title="Russian">
                                <template slot="title"><i class="fa fa-address-book"></i>Russian</template>
                                <b-form-textarea v-model="message_russian" id="message_russian" name="message_russian" placeholder="" rows="5"></b-form-textarea>
                                <i class="flag-icon flag-icon-ru" title="Russia"></i>
                              </b-tab>                                  
                            </b-tabs>
                          </b-card-body>
                        </b-card>
                      </div>      
                    </div>
                    <span @click="addnewtask()" class="btn btn-success ml-0 add-new-task-btn" id="add-task">Send</span>
                  </b-card-body>
                </b-collapse>
              </b-card>                                                                    
            </div>
          </div>

          <div class="col-xl-12"> 
            <div class="default-according">
              <b-card no-body class="mb-1">
                <b-card-header header-tag="div" role="tab" class="bg-secondary">
                  <h5 class="mb-0">
                    <b-button v-b-toggle.sectionHowto><i class="fa fa-question-circle"></i> Howto <span class="digits"></span></b-button>
                  </h5>
                </b-card-header>
                <b-collapse id="sectionHowto" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    1. Market을 선택해주세요. 특별한 경우가 아니라면 ALL이 기본적으로 선택됩니다.<br>
                    2. Version Code는 '0'일 경우 모두에게 노출되며 별도로 지정할 경우에는 지정된값 이상의 Version Code의 앱들에게만 노출됩니다.<br>
                    3. Deadline은 "yyyy-mm-dd HH:mm:ss" 형식으로 입력되며 필수 입력 사항입니다.<br>
                    4. Link와 Image는 선택적으로 입력하세요.<br>
                    5. Message의 경우 English는 필수 입력 사항입니다. 기타 다른 언어들은 선택적으로 입력 해주시면 됩니다.<br>
                    6. 저장후 상태를 ACTIVE로 변경해주어야 정상적으로 앱에서 노출됩니다.<br>
                    7. 한번 삭제된 공지사항은 복구되지 않습니다. 삭제전에 확인 부탁드립니다.
                  </b-card-body>
                </b-collapse>
              </b-card>                                                                    
            </div>
          </div>  
        </div>
      </div>
      <!-- Container-fluid Ends-->
    </div>
  </template>

<script>
  import { mapState } from "vuex";
  import Datepicker from 'vuejs-datepicker';
  import moment from 'moment'  

  export default{
    name:'todo',
    data(){
      return{
        format: "yyyy/MM/dd",

        basic:{
          currentPage: 1,
          totalPages: 0,
        },

        filter:{
          currentPage: 1,
          totalPages: 0,
        },

        selectrow:{
          currentPage: 1,
          totalPages: 0,
        },

        filters: {
            market: { value: '', keys: ['market'] },
            versionCode: { value: '', keys: ['versionCode'] },
            link: { value: '', keys: ['link'] },
            item: { value: '', keys: ['item'] },
            image: { value: '', keys: ['image'] },
            message: { value: '', keys: ['message'] },
            created: { value: '', keys: ['created'] },
            deadline: { value: '', keys: ['deadline'] },
            status: { value: '', keys: ['status'] }
        },

        MarketOptions:[
            { value:'ALL', text: 'All(모든 마켓)', selected: true },
            { value:'GOOGLE', text: 'Google Play'},
            { value:'ITUNES', text: 'iTunes'},
            { value:'ONESTORE', text: 'OneStore'},
            { value:'SAMSUNG', text: 'Samsung'},
            { value:'KDDI', text: 'KDDI'}
        ],

        notice_market : 'ALL',
        notice_link : '',
        notice_image : ''

      }
    },
    components: {
      Datepicker
    },

    computed:{
      ...mapState({
        noticeList: state => state.firebase_notice.todo,
      }),

      formatted(){
        return Vue.filter('todo.checked')(this.value)
      }
    },

    created(){
      this.$store.dispatch('firebase_notice/retrieveTodos')
      this.retrieveTodos();
    },    

    methods:{
      getImgUrl(filename) {
        var images = require.context('../../assets/images/market/', false, /\.png$/)
        return images('./' + filename)
      }, 

      // methods area
      formatDate: function(dt){
        return moment(dt).fromNow();//format('YYYY-MM-DD hh:mm');
      },

      formatDateChecked: function(dt){      
        return moment(String(dt.toDate())).format('YYYY-MM-DD hh:mm')
      },

      retrieveTodos()
      {        
        this.$store.dispatch('firebase_notice/retrieveTodos')
      },

      taskActive(id, status)
      {
        this.$store.dispatch('firebase_notice/taskActive', id)
        this.retrieveTodos();

        if(status == "INACTIVE")
          this.$toasted.show("Notice marked as ACTIVE.", {theme: 'outline', type: 'success', duration: 2000});
        else
          this.$toasted.show("Notice marked as INACTIVE.", {theme: 'outline', type: 'error', duration: 2000});
      },

      tododelete(id, status)
      {
        if(status == "INACTIVE")
        {
          this.$store.dispatch('firebase_notice/tododelete', id)
          this.retrieveTodos();
          this.$toasted.show("Notice has been deleted.",{theme:'outline', type : 'success',duration:2000});
        }
        else
        {
          this.$toasted.show("Notice is ACTIVE status, change to INACTIVE before delete.",{theme:'outline', type : 'error',duration:2000});
        }
      },

      addnewtask()
      {
        if(this.notice_deadline == null)
        {
          this.$toasted.show("Must insert deadline", {theme: 'outline', type: 'success', duration: 2000});
        }
        else if(this.message_english == null)
        {
          this.$toasted.show("Must insert any message", {theme: 'outline', type: 'success', duration: 2000});
        }
        else
        {
          this.$store.dispatch('firebase_notice/addtodo', this)          

          // 앱력 Form을 초기화 시켜줍니다.
          this.notice_market = 'ALL'
          this.notice_versionCode = 0
          this.notice_link = null
          this.notice_image = null
          this.notice_deadline = null

          this.message_english = null
          this.message_korean = null
          this.message_spanish = null
          this.message_portuguese = null
          this.message_french = null
          this.message_german = null
          this.message_russian = null          

          this.$toasted.show("New notice has sent.",{theme:'outline', type : 'success',duration:2000});
          this.retrieveTodos();
        }
      }
    }
  }
</script>
